import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { AbstructVar } from "../../../components/general/general-component/abstruct-component/AbstructVar";
import { VariableExpenses } from "./VariableExpenses";
import SelectDropDown from "../../../components/elements/SelectDropDown";
import {
  filterExpenses,
  getPageListExpenses,
  exportExpenses,
} from "../../../store/Actions/ActionExpenses";
import { useSelectorCustom } from "../../../components/general/general-component/abstruct-component/useSelectorCustom";
import { CheckboxField } from "../../../components/general/general-component/abstruct-component/AbstructForm";
import moment from "moment";
import { notifyError } from "../../../components/general/Notification";

function FilterExpenses({ translate, noPadding, bigTitle }) {
  const { dispatch, langLocal } = AbstructVar();
  const { state, setStateCustom, setLoad } = VariableExpenses();
  const { page_list_expenses } = useSelectorCustom();
  const [loadExport, setLoadExport] = useState(false);
  useEffect(() => {
    dispatch(getPageListExpenses());
  }, []);

  const Filter = (e) => {
    e.preventDefault();
    if (state.account_id !== "") {
      dispatch(
        filterExpenses(
          state.search_value,
          state.date,
          state.expense_statement_id,
          state.revolving,
          state.account_id,
          setLoad
        )
      );
    } else notifyError(translate("choose_account"));
  };

  const Export = (e) => {
    e.preventDefault();
    if (state.expense_statement_id !== "" && state.account_id !== "") {
      dispatch(
        exportExpenses(
          state.search_value,
          state.date,
          state.expense_statement_id,
          state.revolving,
          state.account_id,
          setLoadExport
        )
      );
    } else notifyError(translate("choose_account_and_statement"));
  };

  return (
    <div
      className="filteruser "
      dir={langLocal === "ar" ? "rtl" : "ltr"}
      style={noPadding && { padding: "4px 0px 10px 0px" }}
    >
      {bigTitle ? (
        <h2 className="main_title_color">{translate("search_filter")}</h2>
      ) : (
        <h3>{translate("search_filter")}</h3>
      )}
      <div className="div_filter" style={{ marginTop: "0px" }}>
        <div
          style={{ marginTop: "15px" }}
          className={`${
            langLocal === "ar" ? "margin_left_10" : "margin_right_10"
          } new-input-filter w-24`}
        >
          <input
            type="text"
            className={`input_filter1 ${
              langLocal === "ar" ? "margin_left_25" : "margin_right_25"
            } `}
            placeholder={translate("search")}
            onChange={(e) => setStateCustom("search_value", e.target.value)}
          />
        </div>
        <div
          className={`${
            langLocal === "ar" ? "margin_left_10" : "margin_right_10"
          } margin-top-filter-15 new-input-filter w-24`}
        >
          <input
            type="date"
            className={`input_filter1 ${
              langLocal === "ar" ? "margin_left_25" : "margin_right_25"
            } `}
            placeholder={translate("date")}
            onChange={(e) => setStateCustom("date", e.target.value)}
          />
        </div>
        <div
          className={`${
            langLocal === "ar" ? "margin_left_10" : "margin_right_10"
          } one-select w-24`}
          style={{ fontSize: "14px" }}
        >
          <SelectDropDown
            placeholder={translate("statement")}
            options={page_list_expenses?.expense_statements?.map((type) => ({
              label: `${type?.number} | ${moment(type?.statement_date).format(
                "YYYY-MM-DD"
              )} | ${type?.project.name}`,
              value: type?.id,
            }))}
            varr={state?.expense_statement_id}
            setVarr={(value) => setStateCustom("expense_statement_id", value)}
          />
        </div>
        <div
          className={`${
            langLocal === "ar" ? "margin_left_10" : "margin_right_10"
          } one-select w-24`}
          style={{ fontSize: "14px" }}
        >
          <SelectDropDown
            placeholder={translate("account")}
            options={page_list_expenses?.accounts?.map((account) => ({
              label: account?.name,
              value: account?.id,
            }))}
            varr={state?.account_id}
            setVarr={(value) => setStateCustom("account_id", value)}
          />
        </div>
        <div
          className={`${
            langLocal === "ar" ? "margin_left_10" : "margin_right_10"
          } w-24`}
        >
          <CheckboxField
            key={"revolving"}
            label={"revolved"}
            checked={state["revolving"] || false}
            onChange={(e) => setStateCustom("revolving", e.target.checked)}
            langLocal={langLocal}
            disabled={false}
          />
        </div>
        <div>
          <button
            className={`btn_filter ${
              langLocal === "ar" ? "margin_left_10" : "margin_right_10"
            }`}
            onClick={Filter}
            style={{ marginBottom: "0px" }}
          >
            {state.Load ? "Loading ..." : `${translate("filter")}`}
          </button>

          <button
            className="btn_filter"
            onClick={Export}
            style={{ marginBottom: "0px" }}
          >
            {loadExport ? "Loading ..." : `${translate("export")}`}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FilterExpenses;
